import React from "react";
import { ArrowRight, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function StartYourTransition() {
  return <section data-section-id="31133" id="initiate-system-audit" className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden dark bg-background text-foreground py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/solar_panel_dark_bg.png')] bg-fixed bg-cover bg-center opacity-20" />
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-background to-background mix-blend-multiply" />
        <div className="absolute inset-0 bg-black/40" /> {}
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 text-center max-w-4xl flex flex-col items-center gap-8">
        <div className="space-y-4">
          <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold font-sans text-white tracking-widest uppercase drop-shadow-lg">
            Ready for Reclamation?
          </h2>
          <p className="text-lg md:text-xl font-mono text-primary max-w-2xl mx-auto leading-relaxed drop-shadow-md">
            [SYSTEM STATUS: READY] 
          </p>
        </div>

        {}
        <div className="relative group">
          <div className="absolute -inset-1 bg-primary/30 rounded-none blur-xl opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-pulse" />
          <Button asChild className="relative h-auto py-6 px-12 text-xl font-semibold bg-primary text-primary-foreground hover:bg-primary/90 border-0 rounded-none shadow-[0_0_30px_rgba(57,255,20,0.4)] hover:shadow-[0_0_50px_rgba(57,255,20,0.6)] transition-all duration-300 transform hover:-translate-y-1">
            <Link to="/ExergyAuditPage" className="flex items-center gap-3">
              <Zap className="w-6 h-6 fill-current" />
              <span>INITIATE AUDIT</span>
              <ArrowRight className="w-6 h-6 ml-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}